module.exports = __webpack_public_path__ + "img/3.621d72e9.png";